module.exports = __webpack_public_path__ + "assets/img/0b676d5dbf47b23b72c88400145a14d7.png";